export default __webpack_public_path__ + "static/media/disright.ca6efc91.png";